import { observable, action, when } from 'mobx'

import 'firebase/auth'
import 'firebase/firestore'

import { FirebaseBackedDoc } from '../../firebase'
import { ContentMenuTextTypes } from '../storydoc/storydocStoreContent'

class Window {
  @observable width = window.innerWidth
  @observable height = window.innerHeight

  constructor () {
    !window.cordova && window.addEventListener('resize', () => {
      this.updateViewportHeight()
      this.updateViewportWidth()
    }, true)

    window.cordova && window.addEventListener('orientationchange', () => {
      this.updateViewportWidth()
      this.updateViewportHeight()

      if (location.hash === '#/') {
        setTimeout(() => location.reload(), 300)
      }

    }, true)

    setInterval(() => {
      window.scrollTo(0, -1)
      this.updateViewportHeight()
      this.updateViewportWidth()
    }, 1000)
  }

  @action
  updateViewportHeight = () => {
    if (window.innerHeight !== this.height) {
      this.height = window.innerHeight
      // console.log('current height is ', this.height)
    }
  }

  @action
  updateViewportWidth = () => {
    if (window.innerWidth !== this.width) {
      this.width = window.innerWidth
      // console.log('current width is ', this.width)
    }
  }
}

class Menu {
  @observable open = false
  @observable submenuType: 'quellen' | 'sources' | ContentMenuTextTypes | '' = ''
  @observable language = localStorage.getItem('language') || 'de'
  @observable showProgressBar = true
  @observable showYellowProgress = true
}

class CurrentStory {
  @observable id: string | null
  @observable position: number
  @observable scrollerData: number[] = []
  @observable paused = false
  @observable play = false
  @observable timelineExpanded = false
  @observable vertiefungExpanded = false
}

export class UserProfile extends FirebaseBackedDoc {
  @observable lastLogin: Date = new Date()
  @observable dev: boolean = false

  @observable numberVotes: number | undefined = undefined
  @observable secondsWatched: number | undefined = undefined

  constructor (path: string) {
    super(path)
    when(() => this.isSynced, () => {
      this.setTimestamp()
    })
  }

  @action setTimestamp () {
    this.lastLogin = new Date()
    this.dev = process.env.NODE_ENV === 'development'
    this.saveAll()
  }
}

export class CommonStore {
  menu: Menu
  window: Window
  currentStory: CurrentStory

  constructor () {
    this.menu = new Menu()
    this.window = new Window()
    this.currentStory = new CurrentStory()
  }
}



// WEBPACK FOOTER //
// ./src/modules/common/CommonStore.tsx